import { c as _c } from "react/compiler-runtime";
import { Tooltip as TooltipPrimitive } from '@base-ui/react/tooltip';
import * as React from 'react';
import { cn } from '@/lib/utils';
type PositionerProps = Pick<React.ComponentProps<typeof TooltipPrimitive.Positioner>, 'align' | 'alignOffset' | 'anchor' | 'collisionBoundary' | 'collisionPadding' | 'side' | 'sideOffset' | 'sticky'>;
type PortalProps = Pick<React.ComponentProps<typeof TooltipPrimitive.Portal>, 'container' | 'keepMounted'>;
type TooltipContentProps = React.ComponentProps<typeof TooltipPrimitive.Popup> & PositionerProps & PortalProps & {
  avoidCollisions?: boolean | undefined;
  popupRef?: React.Ref<HTMLDivElement> | undefined;
  positionerClassName?: string | undefined;
};
function TooltipProvider(t0) {
  const $ = _c(6);
  let delayDuration;
  let props;
  if ($[0] !== t0) {
    ({
      delayDuration,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = delayDuration;
    $[2] = props;
  } else {
    delayDuration = $[1];
    props = $[2];
  }
  const t1 = delayDuration ?? 0;
  let t2;
  if ($[3] !== props || $[4] !== t1) {
    t2 = <TooltipPrimitive.Provider data-slot="tooltip-provider" delay={t1} {...props} />;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function Tooltip(t0) {
  const $ = _c(10);
  let delayDuration;
  let props;
  if ($[0] !== t0) {
    ({
      delayDuration,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = delayDuration;
    $[2] = props;
  } else {
    delayDuration = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== delayDuration) {
    t1 = delayDuration === undefined ? {} : {
      delayDuration
    };
    $[3] = delayDuration;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props) {
    t2 = <TooltipPrimitive.Root data-slot="tooltip" {...props} />;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <TooltipProvider {...t1}>{t2}</TooltipProvider>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function TooltipTrigger(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function TooltipArrowSvg(t0) {
  const $ = _c(11);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("h-2.5 w-5", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M9.66437 2.60207L4.80758 6.97318C4.07308 7.63423 3.11989 8 2.13172 8H0V10H20V8H18.5349C17.5468 8 16.5936 7.63423 15.8591 6.97318L11.0023 2.60207C10.622 2.2598 10.0447 2.25979 9.66437 2.60207Z" className="fill-[canvas]" />;
    t3 = <path d="M8.99542 1.85876C9.75604 1.17425 10.9106 1.17422 11.6713 1.85878L16.5281 6.22989C17.0789 6.72568 17.7938 7.00001 18.5349 7.00001L15.89 7L11.0023 2.60207C10.622 2.2598 10.0447 2.2598 9.66436 2.60207L4.77734 7L2.13171 7.00001C2.87284 7.00001 3.58774 6.72568 4.13861 6.22989L8.99542 1.85876Z" className="fill-gray-200 dark:fill-none" />;
    t4 = <path d="M10.3333 3.34539L5.47654 7.71648C4.55842 8.54279 3.36693 9 2.13172 9H0V8H2.13172C3.11989 8 4.07308 7.63423 4.80758 6.97318L9.66437 2.60207C10.0447 2.25979 10.622 2.2598 11.0023 2.60207L15.8591 6.97318C16.5936 7.63423 17.5468 8 18.5349 8H20V9H18.5349C17.2998 9 16.1083 8.54278 15.1901 7.71648L10.3333 3.34539Z" className="dark:fill-gray-300" />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props || $[9] !== t1) {
    t5 = <svg width="20" height="10" viewBox="0 0 20 10" fill="none" className={t1} aria-hidden={true} {...props}>{t2}{t3}{t4}</svg>;
    $[8] = props;
    $[9] = t1;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function TooltipContent(t0) {
  const $ = _c(43);
  let align;
  let alignOffset;
  let anchor;
  let avoidCollisions;
  let children;
  let className;
  let collisionBoundary;
  let collisionPadding;
  let container;
  let keepMounted;
  let popupRef;
  let positionerClassName;
  let props;
  let side;
  let sticky;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      align,
      alignOffset,
      anchor,
      collisionBoundary,
      collisionPadding,
      avoidCollisions,
      sideOffset: t1,
      side,
      sticky,
      children,
      container,
      keepMounted,
      popupRef,
      positionerClassName,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = align;
    $[2] = alignOffset;
    $[3] = anchor;
    $[4] = avoidCollisions;
    $[5] = children;
    $[6] = className;
    $[7] = collisionBoundary;
    $[8] = collisionPadding;
    $[9] = container;
    $[10] = keepMounted;
    $[11] = popupRef;
    $[12] = positionerClassName;
    $[13] = props;
    $[14] = side;
    $[15] = sticky;
    $[16] = t1;
  } else {
    align = $[1];
    alignOffset = $[2];
    anchor = $[3];
    avoidCollisions = $[4];
    children = $[5];
    className = $[6];
    collisionBoundary = $[7];
    collisionPadding = $[8];
    container = $[9];
    keepMounted = $[10];
    popupRef = $[11];
    positionerClassName = $[12];
    props = $[13];
    side = $[14];
    sticky = $[15];
    t1 = $[16];
  }
  const sideOffset = t1 === undefined ? 10 : t1;
  let t2;
  if ($[17] !== avoidCollisions) {
    t2 = avoidCollisions === false ? {
      side: "none",
      align: "none",
      fallbackAxisSide: "none"
    } : undefined;
    $[17] = avoidCollisions;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  let t3;
  if ($[19] !== className) {
    t3 = cn("z-50 flex w-fit origin-(--transform-origin) flex-col rounded-md bg-[canvas] px-2 py-1 text-sm text-[canvastext] scheme-light shadow-lg shadow-gray-200 outline-1 outline-gray-200 transition-[transform,scale,opacity] data-ending-style:scale-90 data-ending-style:opacity-0 data-instant:transition-none data-starting-style:scale-90 data-starting-style:opacity-0 dark:scheme-dark dark:shadow-none dark:-outline-offset-1 dark:outline-gray-300", className);
    $[19] = className;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TooltipPrimitive.Arrow data-slot="tooltip-arrow" className="flex data-[side=bottom]:-top-2 data-[side=bottom]:rotate-0 data-[side=left]:-right-3.25 data-[side=left]:rotate-90 data-[side=right]:-left-3.25 data-[side=right]:-rotate-90 data-[side=top]:-bottom-2 data-[side=top]:rotate-180"><TooltipArrowSvg /></TooltipPrimitive.Arrow>;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== children || $[23] !== popupRef || $[24] !== props || $[25] !== t3) {
    t5 = <TooltipPrimitive.Popup ref={popupRef} data-slot="tooltip-content" className={t3} {...props}>{t4}{children}</TooltipPrimitive.Popup>;
    $[22] = children;
    $[23] = popupRef;
    $[24] = props;
    $[25] = t3;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] !== align || $[28] !== alignOffset || $[29] !== anchor || $[30] !== collisionBoundary || $[31] !== collisionPadding || $[32] !== positionerClassName || $[33] !== side || $[34] !== sideOffset || $[35] !== sticky || $[36] !== t2 || $[37] !== t5) {
    t6 = <TooltipPrimitive.Positioner className={positionerClassName} align={align} alignOffset={alignOffset} anchor={anchor} collisionBoundary={collisionBoundary} collisionPadding={collisionPadding} collisionAvoidance={t2} side={side} sideOffset={sideOffset} sticky={sticky}>{t5}</TooltipPrimitive.Positioner>;
    $[27] = align;
    $[28] = alignOffset;
    $[29] = anchor;
    $[30] = collisionBoundary;
    $[31] = collisionPadding;
    $[32] = positionerClassName;
    $[33] = side;
    $[34] = sideOffset;
    $[35] = sticky;
    $[36] = t2;
    $[37] = t5;
    $[38] = t6;
  } else {
    t6 = $[38];
  }
  let t7;
  if ($[39] !== container || $[40] !== keepMounted || $[41] !== t6) {
    t7 = <TooltipPrimitive.Portal container={container} keepMounted={keepMounted}>{t6}</TooltipPrimitive.Portal>;
    $[39] = container;
    $[40] = keepMounted;
    $[41] = t6;
    $[42] = t7;
  } else {
    t7 = $[42];
  }
  return t7;
}
export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };